import React, { useEffect } from "react";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import { Tab, Tabs, TabPanel, TabList } from "react-tabs";
import { useState } from "react";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { useForm } from "react-hook-form";
import Loader from "../../../Common/Loader/loader";
import { AllShiftMaster } from "../../../Apis/shiftMasterApi";
import {
  MulipleClearanceReportCircleWiseReportResult,
  MulipleClearanceReportZoneWiseReportResult,
  MulipleMoreThanThreeTimeReportZoneWiseReportResult,
  MulipleMultipleTimeReportCircleWiseReportResult,
  MulipleMultipleTimeReportTotalReportResult,
  MulipleTwoTimeReportZoneWiseTotalReportResult,
  MulipleOneTimeReportZoneWiseReportResult,
  MulipleOneTimeReportReportTotalResult,
  MulipleThreeTimeReportZoneWiseReportResult,
  MulipleTwoTimeReportZoneWiseReportResult,
  MulipleOneTimeReportZoneWiseReportTotalResult,
  MulipleTwoTimeReportZoneWiseReportTotalResult,
  MulipleThreeTimeReportZoneWiseReportTotalResult,
  MulipleMoreThanThreeTimeReportZoneWiseReportTotalResult,
  ZoneWiseExistingGvp,
  TotalExistingGvp,
  CircleWiseTotalExistingGvp,
  CircleWiseExistingGvp,
  GetAllClearedCollectionTransaction,
} from "../../../Apis/gvpClearanceReportApi";
import { useNavigate } from "react-router-dom";
import isGHMC, { formattedDate, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";

function GVPMultipleClearence() {
  const multipleReportDate = localStorage.getItem("multipleReportDate");
  const MultipleReportShift = localStorage.getItem("MultipleReportShift");
  const multipleCircleShift = localStorage.getItem("multipleCircleShift");
  const MultipleCircleDate = localStorage.getItem("MultipleCircleDate");
  const {
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [formInput, setFormInput] = useState({
    Date: multipleReportDate || getCurrentDateTime(),
    shiftId: MultipleReportShift || 1,
  });
  const [formInput1, setFormInput1] = useState({
    Date: MultipleCircleDate || getCurrentDateTime(),
    shiftId: multipleCircleShift || 1,
  });

  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [shiftData, setShiftData] = useState([]);
  const [getZoneReport, setgetZoneReport] = useState([]);
  const [getCircleReport, setgetCircleReport] = useState([]);
  const [shiftType, setShiftType] = useState([]);
  const [circleZonewisereportcircle, setcircleZonewisereportcircle] = useState(
    []
  );
  const isProd = isGHMC();

  useEffect(() => {
    const savedTab = localStorage.getItem("MultipleReportSelectedTab");
    if (savedTab) {
      setSelectedTab(parseInt(savedTab, 10));
    }
  }, []);

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    localStorage.setItem("MultipleReportSelectedTab", index);
  };

  const fetchShiftData = async () => {
    setIsOptionsLoading(true);
    try {
      const response = await AllShiftMaster();
      setShiftType(response);
      // setIsOptionsLoading(false);
    } catch (error) {
      //  console.log(error);
    }
  };

  const searchZoneReport = async (data) => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleClearanceReportZoneWiseReportResult({
        Date: formInput.Date,
        ShiftId: formInput.shiftId,
      });
      const zoneDataResponse = res.data.map((zoneData) => ({
        ...zoneData,
        zone: zoneData.zoneName,
      }));
      setgetZoneReport(zoneDataResponse);
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const searchCircleReport = async (data) => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleClearanceReportCircleWiseReportResult({
        Date: formInput1.Date,
        ShiftId: formInput1.shiftId,
        zoneId: "",
      });
      const circleDataResponse = res.data.map((circleData) => ({
        ...circleData,
        circle: circleData.circleName,
      }));
      // setgetCircleReport(res.data)
      setgetCircleReport(circleDataResponse);
    } catch (error) {
    } finally {
      setIsOptionsLoading(false);
    }
  };

  useEffect(() => {
    fetchShiftData();
    searchZoneReport();
    searchCircleReport();
  }, []);

  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
      callback(searchZoneReport);
      callback(searchCircleReport);
    }
  };

  // const downloadZoneAsExcel = () => {
  //   const ws = XLSX.utils.json_to_sheet(getZoneReport);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "ZoneWiseMultipleClearanceReports");
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  //   });
  //   const downloadLink = document.createElement("a");
  //   downloadLink.href = URL.createObjectURL(data);
  //   downloadLink.download = "ZoneWiseMultipleClearanceReports.xlsx";
  //   downloadLink.click();
  // };
  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;

  const downloadZoneAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Zone Wise GVPs Multiple Clearance Report on ${formattedDate(formInput.Date)} & ${getShiftName(formInput.shiftId)}`;
    const downloadDateTime = `Reported on: ${formattedDates},${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 9); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 9; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Zone Wise GVPs Multiple Clearance Report", ""]);
    worksheet.mergeCells(2, 2, 2, 9); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = 
    `Zone Wise GVPs Multiple Clearance Report as on ${formInput.Date?formattedDate(formInput.Date):getCurrentISTDate()} - ${getShiftName(formInput.shiftId)} - (at ${getCurrentDateTime1()})`;
    

    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 9; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Existing GVPs",
      "Total GVPs Cleared",
      "1 Times",
      "2 Times",
      "3 Times",
      ">3 Times",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 13) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
        };
      }
    });

    // Initialize totals
    let totalExistingGVPs = 0;
    let totalClearedGVPs = 0;
    let totalOneTimeCp = 0;
    let totalTwoTimeCp = 0;
    let totalThreeTimeCp = 0;
    let totalMoreThreeTimeCp = 0;

    // Add data rows
    getZoneReport.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.zoneName ?? "N/A",
          item.existingCp ?? "N/A",
          item.totalClearedCp ?? "N/A",
          item.oneTimeCp ?? "N/A",
          item.twoTimeCp ?? "N/A",
          item.threeTimeCp ?? "N/A",
          item.moreThreeTimeCp ?? "N/A",
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 13) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });

      // Calculate totals
      totalExistingGVPs += item.existingCp;
      totalClearedGVPs += item.totalClearedCp;
      totalOneTimeCp += item.oneTimeCp;
      totalTwoTimeCp += item.twoTimeCp;
      totalThreeTimeCp += item.threeTimeCp;
      totalMoreThreeTimeCp += item.moreThreeTimeCp;
    });

    // Add totals row
    const totalRow = worksheet.addRow([
      "", // S.No for the total row
      "Total", // Label for total row
      totalExistingGVPs, // Calculated total for "Existing GVPs"
      totalClearedGVPs, // Calculated total for "Total Cleared GVPs"
      totalOneTimeCp, // Calculated total for "1 Time"
      totalTwoTimeCp, // Calculated total for "2 Time"
      totalThreeTimeCp, // Calculated total for "3 Time"
      totalMoreThreeTimeCp, // Calculated total for ">3 Time"
    ]);

    // Style the totals row
    totalRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 24 },
      { width: 24 },
      { width: 26 },
      { width: 20 },
      { width: 23 },
      { width: 24 },
      { width: 24 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ZoneWiseMultipleClearanceReports.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const downloadCircleAsExcel = async () => {
    // Get the current date and time
    const currentDate = new Date();
    const formattedDateCircle = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1
      }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;

    const cumulativeHeadingReport = "Circle Wise Multiple Clearance Reports";
    const downloadDateTime = `Reported on: ${formattedDateCircle}, ${formattedTime}`;

    // Create a new Excel workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Circles");

    // Define bold font style
    const boldFont = { bold: true };

    // Add and merge the download date and time row
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 9); // Adjust merging range if necessary
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Apply styles to merged cells (B1 to I1)
    for (let col = 2; col <= 9; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // Add and merge the report heading row
    worksheet.addRow(["", "", "Circle Wise Multiple Clearance Reports", ""]);
    worksheet.mergeCells(2, 2, 2, 9); // Adjust merging range if necessary
    worksheet.getCell(2, 2).value = `Circle Wise Multiple Clearance Reports on ${formattedDate(formInput1.Date)} & ${getShiftName(formInput1.shiftId)}`;
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Apply styles to merged cells (B2 to I2)
    for (let col = 2; col <= 9; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add an empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font and red background
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Circle",
      "Existing GVPs",
      "Total GVPs Cleared",
      "1 Time",
      "2 Times",
      "3 Times",
      ">03 Times",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 13) {
        // Apply background color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Light red background
        };
      }
    });

    // Initialize totals
    let totalExistingGVPs = 0;
    let totalClearedGVPs = 0;
    let totalOneTimeCp = 0;
    let totalTwoTimeCp = 0;
    let totalThreeTimeCp = 0;
    let totalMoreThreeTimeCp = 0;

    // Add data rows dynamically from the `getCircleReport` array
    getCircleReport.forEach((item, index) => {
      // Sum up the totals
      totalExistingGVPs += item.existingCp;
      totalClearedGVPs += item.totalClearedCp;
      totalOneTimeCp += item.oneTimeCp;
      totalTwoTimeCp += item.twoTimeCp;
      totalThreeTimeCp += item.threeTimeCp;
      totalMoreThreeTimeCp += item.moreThreeTimeCp;

      worksheet
        .addRow([
          index + 1,
          item.circleName,
          item.existingCp,
          item.totalClearedCp,
          item.oneTimeCp,
          item.twoTimeCp,
          item.threeTimeCp,
          item.moreThreeTimeCp,
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 4) {
            // Left align columns 1-4
            cell.alignment = { horizontal: "left" };
          } else {
            // Center align other columns
            cell.alignment = { horizontal: "left" };
          }
        });
    });

    // Add total row
    const totalRow = worksheet.addRow([
      "",
      "Total", // S.No and Circle will not be totaled, so set them as labels
      totalExistingGVPs,
      totalClearedGVPs,
      totalOneTimeCp,
      totalTwoTimeCp,
      totalThreeTimeCp,
      totalMoreThreeTimeCp,
    ]);

    // Apply styles to the total row
    totalRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      // if (colNumber >= 1 && colNumber <= 13) {
      //   cell.fill = {
      //     type: "pattern",
      //     pattern: "solid",
      //     fgColor: { argb: "FFFFFF" }, // Light green background for total row
      //   };
      // }
    });

    // Set column widths
    worksheet.columns = [
      { width: 5 }, // S.No
      { width: 20 }, // Circle
      { width: 24 }, // Existing GVPs
      { width: 24 }, // Total Cleared GVPs
      { width: 26 }, // 1 Time
      { width: 20 }, // 2 Times
      { width: 20 }, // 3 Times
      { width: 20 }, // >03 Times
    ];

    // Save the workbook to a file and trigger download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "CircleWiseMultipleClearanceReports.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };


  const getShiftName = (shiftId) => {
    const shift = shiftType.find((s) => s.shiftId === parseInt(shiftId));
    return shift ? shift.shiftName : "N/A";
  };

  const handleZoneClick = async (zoneId) => {
    // searchCircleReport(zoneId);
    setIsOptionsLoading(true);
    try {
      const res = await MulipleClearanceReportCircleWiseReportResult({
        Date: formInput.Date,
        ShiftId: formInput.shiftId,
        zoneId: zoneId,
      });
      // handleOneTimeClick(zoneId);
      navigate("/multi-clearence--inner-report", { state: { data: res.data, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      // console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const zoneColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      //    sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "100px",
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      //   sortable: true,
      cell: (row) => (
        <span
          style={{ color: `${row.zoneName === "Total" ? "black" : "blue"}`, cursor: "pointer" }}
          onClick={() => row.zoneName != "Total" && handleZoneClick(row["zoneId"])}
        >
          {row["zoneName"]}
        </span>
      ), // Render the column without onClick function
    },
    {
      name: "Existing GVPs",
      selector: (row) => row["existingCp"],
      width: "230px",
      //    sortable: true,
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalZoneExistingGvpClick();
            } else {
              handleZoneExistingGvpClick(row);
            }
          }}
        >
          {row["existingCp"]}
        </span>
      ),
    },
    {
      name: "Total GVPs Cleared",
      selector: (row) => row["totalClearedCp"],
      width: "230px",
      //  sortable: true,
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalZoneTotalGvpClearedClick();
            } else {
              handleZoneTotalGvpClearedClick(row);
            }
          }}
        >
          {row["totalClearedCp"]}
        </span>
      ),
    },
    {
      name: "1 Time",
      selector: (row) => row["oneTimeCp"],
      //    sortable: true,
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalOneTimeClick();
            } else {
              handleOneTimeClick(row);
            }
          }}
        >
          {row["oneTimeCp"]}
        </span>
      ),
      width: "130px",
    },
    {
      name: "2 Times",
      selector: (row) => row["twoTimeCp"],
      //    sortable: true,
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalTwoTimeClick();
            } else {
              handleTwoTimeClick(row);
            }
          }}
        >
          {row["twoTimeCp"]}
        </span>
      ),
      width: "130px",
    },
    {
      name: "3 Times",
      selector: (row) => row["threeTimeCp"],
      //    sortable: true,
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalThreeTimeClick();
            } else {
              handleThreeTimeClick(row);
            }
          }}
        >
          {row["threeTimeCp"]}
        </span>
      ),
      width: "130px",
    },
    {
      name: " >3 Times",
      selector: (row) => row["moreThreeTimeCp"],
      //  sortable: true,
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.zoneName === "Total") {
              handleTotalMoreThanThreeTimeClick();
            } else {
              handleMoreThanThreeTimeClick(row);
            }
          }}
        >
          {row["moreThreeTimeCp"]}
        </span>
      ),
    },
  ];

  const circleColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      //     sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "100px",
    },

    {
      name: "Circle",
      selector: (row) => row["circleName"],
      //    sortable: true,
      cell: (row) => (
        <span onClick={() => handleCircleClick(row["circleId"])}>
          {row["circleName"]}
        </span>
      ), // Render the column without onClick function
    },
    {
      name: "Existing GVPs",
      selector: (row) => row["existingCp"],
      width: "230px",
      //  sortable: true,
      cell: (
        row // Render with onClick function and blue color for all columns except "Circle Name"
      ) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleTotalCircleExistingGvpClick();
            } else {
              handleCircleExistingGvpClick(row["circleId"]);
            }
          }}
        >
          {row["existingCp"]}
        </span>
      ),
    },
    {
      name: "Total GVPs Cleared",
      width: "230px",
      selector: (row) => row["totalClearedCp"],
      //   sortable: true,
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleTotalCircleTotalGvpClearedClick();
            } else {
              handleCircleTotalGvpClearedClick(row["circleId"]);
            }
          }}
        >
          {row["totalClearedCp"]}
        </span>
      ),
    },
    {
      name: "1 Time",
      selector: (row) => row["oneTimeCp"],
      //   sortable: true,
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleCircleOneTimeTotalClick();
            } else {
              handleCircleOneTimeClick(row);
            }
          }}
        >
          {row["oneTimeCp"]}
        </span>
      ),
      width: "130px",
    },
    {
      name: "2 Times",
      selector: (row) => row["twoTimeCp"],
      //  sortable: true,
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleCircleTwoTimeTotalClick();
            } else {
              handleCircleTwoTimeClick(row);
            }
          }}
        >
          {row["twoTimeCp"]}
        </span>
      ),
      width: "130px",
    },
    {
      name: "3 Times",
      selector: (row) => row["threeTimeCp"],
      //   sortable: true,
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleCircleThreeTimeTotalClick();
            } else {
              handleCircleThreeTimeClick(row);
            }
          }}
        >
          {row["threeTimeCp"]}
        </span>
      ),
      width: "130px",
    },
    {
      name: " >3 Times",
      width: "15%",
      selector: (row) => row["moreThreeTimeCp"],
      //  sortable: true,
      cell: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => {
            if (row.circleName === "Total") {
              handleCircleMorethanThreeTimeTotalClick();
            } else {
              handleCircleMorethanThreeTimeClick(row);
            }
          }}
        >
          {row["moreThreeTimeCp"]}
        </span>
      ),
    },
  ];

  const handleZoneExistingGvpClick = async (zone) => {
    // searchCircleReport(zoneId);
    setIsOptionsLoading(true);
    try {
      const res = await ZoneWiseExistingGvp({
        Date: formInput.Date,
        ShiftId: formInput.shiftId,
        zoneId: zone.zoneId,
      });
      navigate("/multi-clearence-existing-gvp-inner-report", 
        { state: { data: res.data, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } }
    );
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalZoneExistingGvpClick = async () => {
    // searchCircleReport(zoneId);
    setIsOptionsLoading(true);
    try {
      const res = await TotalExistingGvp({
        Date: formInput.Date,
        ShiftId: formInput.shiftId,
      });
      navigate("/multi-clearence-existing-gvp-inner-report", { state: { data: res.data, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleZoneTotalGvpClearedClick = async (zone) => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: formInput.Date,
        ZoneId: zone.zoneId,
        ShiftId: formInput.shiftId,
      };
      const response = await GetAllClearedCollectionTransaction(requestData);
      navigate("/gvp-inner-cleared-report", { state: { data: response.data, deleteOption: false, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalZoneTotalGvpClearedClick = async (zone) => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: formInput.Date,
        ShiftId: formInput.shiftId,
      };
      const response = await GetAllClearedCollectionTransaction(requestData);
      navigate("/gvp-inner-cleared-report",  { state: { data: response.data, deleteOption: false, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleZoneUniqueGvpClearedClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      const startTime = "00:00";
      const endTime = "23:59";

      // Concatenate start and end times with the date
      const startDate = `${formInput.Date}T${startTime}`;
      const endDate = `${formInput.Date}T${endTime}`;
      const res = await MulipleOneTimeReportZoneWiseReportResult({
        startDate,
        endDate,
        ShiftId: formInput.shiftId,
        zoneId: zoneId.zoneId,
        circleId: "",
      });
      navigate("/multi-clearence-gvp-inner-report", { state: res.data });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleOneTimeClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleOneTimeReportZoneWiseReportResult({
        startDate: formInput.Date,
        ShiftId: formInput.shiftId,
        zoneId: zoneId.zoneId,
        circleId: "",
      });
      navigate("/multi-clearence-gvp-inner-report", { state: { data: res.data, deleteOption: false, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalOneTimeClick = async () => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleOneTimeReportZoneWiseReportTotalResult({
        startDate: formInput.Date,
        ShiftId: formInput.shiftId,
      });
      navigate("/multi-clearence-gvp-inner-report", { state: { data: res.data, deleteOption: false, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTwoTimeClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleTwoTimeReportZoneWiseReportResult({
        startDate: formInput.Date,
        ShiftId: formInput.shiftId,
        zoneId: zoneId.zoneId,
        circleId: "",
      });
      navigate("/multi-clearence-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      // console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalTwoTimeClick = async () => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleTwoTimeReportZoneWiseReportTotalResult({
        startDate: formInput.Date,
        ShiftId: formInput.shiftId,
      });
      navigate("/multi-clearence-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      // console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleThreeTimeClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleThreeTimeReportZoneWiseReportResult({
        startDate: formInput.Date,
        ShiftId: formInput.shiftId,
        zoneId: zoneId.zoneId,
        circleId: "",
      });
      navigate("/multi-clearence-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalThreeTimeClick = async () => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleThreeTimeReportZoneWiseReportTotalResult({
        startDate: formInput.Date,
        ShiftId: formInput.shiftId,
      });
      navigate("/multi-clearence-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleMoreThanThreeTimeClick = async (zoneId) => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleMoreThanThreeTimeReportZoneWiseReportResult({
        startDate: formInput.Date,
        ShiftId: formInput.shiftId,
        zoneId: zoneId.zoneId,
      });
      navigate("/multi-clearence-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalMoreThanThreeTimeClick = async () => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleMoreThanThreeTimeReportZoneWiseReportTotalResult(
        {
          startDate: formInput.Date,
          ShiftId: formInput.shiftId,
        }
      );
      navigate("/multi-clearence-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput.Date, shiftName: getShiftName(formInput.shiftId) } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleCircleOneTimeClick = async (circle) => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleOneTimeReportZoneWiseReportResult({
        startDate: formInput1.Date,
        ShiftId: formInput1.shiftId,
        circleId: circle.circleId,
        zoneId: "",
      });
      navigate("/multi-clearence-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      //   console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleCircleOneTimeTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleOneTimeReportReportTotalResult({
        startDate: formInput1.Date,
        ShiftId: formInput1.shiftId,
      });
      navigate("/multi-clearence-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      //   console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleCircleTwoTimeClick = async (circle) => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleTwoTimeReportZoneWiseReportResult({
        startDate: formInput1.Date,
        ShiftId: formInput1.shiftId,
        circleId: circle.circleId,
        zoneId: "",
      });
      navigate("/multi-clearence-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      //console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleCircleTwoTimeTotalClick = async (circle) => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleTwoTimeReportZoneWiseTotalReportResult({
        startDate: formInput1.Date,
        ShiftId: formInput1.shiftId,
      });
      navigate("/multi-clearence-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      //console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleCircleThreeTimeClick = async (circle) => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleThreeTimeReportZoneWiseReportResult({
        startDate: formInput1.Date,
        ShiftId: formInput1.shiftId,
        zoneId: "",
        circleId: circle.circleId,
      });
      navigate("/multi-clearence-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleCircleThreeTimeTotalClick = async () => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleThreeTimeReportZoneWiseReportTotalResult({
        startDate: formInput1.Date,
        ShiftId: formInput1.shiftId,
      });
      navigate("/multi-clearence-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleCircleMorethanThreeTimeClick = async (circle) => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleMultipleTimeReportCircleWiseReportResult({
        startDate: formInput1.Date,
        ShiftId: formInput1.shiftId,
        circleId: circle.circleId,
      });
      navigate("/multi-clearence-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };
  const handleCircleMorethanThreeTimeTotalClick = async (circle) => {
    setIsOptionsLoading(true);
    try {
      const res = await MulipleMultipleTimeReportTotalReportResult({
        startDate: formInput1.Date,
        ShiftId: formInput1.shiftId,
      });
      navigate("/multi-clearence-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleCircleExistingGvpClick = async (circleId) => {
    setIsOptionsLoading(true);
    try {
      const res = await CircleWiseExistingGvp({
        Date: formInput1.Date,
        ShiftId: formInput1.shiftId,
        circleId: circleId,
      });
      navigate("/multi-clearence-existing-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalCircleExistingGvpClick = async () => {
    setIsOptionsLoading(true);
    try {
      const res = await CircleWiseTotalExistingGvp({
        Date: formInput1.Date,
        ShiftId: formInput1.shiftId,
      });
      navigate("/multi-clearence-existing-gvp-inner-report",  { state: { data: res.data, deleteOption: false, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      //  console.log(error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleCircleTotalGvpClearedClick = async (circleId) => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: formInput1.Date,
        ShiftId: formInput1.shiftId,
        circleId: circleId,
      };
      const response = await GetAllClearedCollectionTransaction(requestData);
      navigate("/gvp-inner-cleared-report",  { state: { data: response.data, deleteOption: false, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleTotalCircleTotalGvpClearedClick = async () => {
    try {
      setIsOptionsLoading(true);
      const requestData = {
        date: formInput1.Date,
        ShiftId: formInput1.shiftId,
      };
      const response = await GetAllClearedCollectionTransaction(requestData);
      navigate("/gvp-inner-cleared-report",  { state: { data: response.data, deleteOption: false, formatDate: formInput1.Date, shiftName: getShiftName(formInput1.shiftId) } });
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleCircleClick = async (circleId) => {
    handleCircleOneTimeClick(circleId);
  };

  const calculateGVPMultipleClearnceZoneTotals = (data) => {
    const totals = {
      sno: "Total",
      zoneName: "Total",
      existingCp: 0,
      totalClearedCp: 0,
      oneTimeCp: 0,
      twoTimeCp: 0,
      threeTimeCp: 0,
      moreThreeTimeCp: 0,
    };

    data.forEach((row) => {
      totals.existingCp += row.existingCp || 0;
      totals.totalClearedCp += row.totalClearedCp || 0;
      totals.oneTimeCp += row.oneTimeCp || 0;
      totals.twoTimeCp += row.twoTimeCp || 0;
      totals.threeTimeCp += row.threeTimeCp || 0;
      totals.moreThreeTimeCp += row.moreThreeTimeCp || 0;
    });
    return totals;
  };

  const totalZoneRow = calculateGVPMultipleClearnceZoneTotals(getZoneReport);
  const GVPMultipleClearnceZoneDataWithTotal = [...getZoneReport, totalZoneRow];

  const calculateGVPMultipleClearnceTotals = (data) => {
    const totals = {
      sno: "Total",
      circleName: "Total",
      existingCp: 0,
      totalClearedCp: 0,
      oneTimeCp: 0,
      twoTimeCp: 0,
      threeTimeCp: 0,
      moreThreeTimeCp: 0,
    };

    data.forEach((row) => {
      totals.existingCp += row.existingCp || 0;
      totals.totalClearedCp += row.totalClearedCp || 0;
      totals.oneTimeCp += row.oneTimeCp || 0;
      totals.twoTimeCp += row.twoTimeCp || 0;
      totals.threeTimeCp += row.threeTimeCp || 0;
      totals.moreThreeTimeCp += row.moreThreeTimeCp || 0;
    });
    return totals;
  };
  const totalCircleRow = calculateGVPMultipleClearnceTotals(getCircleReport);
  const GVPMultipleClearnceDataWithTotal = [...getCircleReport, totalCircleRow];

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 className="text-start mb-3">GVP Multiple Clearance Report</h4>
            <div className="card">
              <div className="card-body p-3">
                <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
                  <TabList style={{ display: "flex" }}>
                    <Tab
                      className={`datatable_tabs ${isProd
                          ? selectedTab === 0
                            ? "active-ghmc"
                            : "active-swm"
                          : selectedTab === 0
                            ? "active-default"
                            : "inactive-default"
                        }`}
                    >
                      Zone Wise GVPs Multiple Clearance Report
                    </Tab>
                    <Tab
                      className={`datatable_tabs ${isProd
                          ? selectedTab === 1
                            ? "active-ghmc"
                            : "active-swm"
                          : selectedTab === 1
                            ? "active-default"
                            : "inactive-default"
                        }`}
                    >
                      Circle Wise GVPs Multiple Clearance Report
                    </Tab>
                  </TabList>

                  {/* Web View Tab */}
                  <TabPanel>
                    {isOptionsLoading && <Loader />}
                    <div className="row mt-3 align-content-center">
                      <div className="col-md-10">
                        <form
                          onSubmit={handleSubmit(searchZoneReport)}
                          onKeyDown={(e) => {
                            handleKeyDown(e, handleSubmit);
                          }}
                        >
                          <div
                            className="row align-content-center"
                            style={{ textAlign: "justify" }}
                          >
                            <div className="col-md-3">
                              <label htmlFor="Date">Date:</label>
                              <input
                                type="date"
                                name="date"
                                value={formInput.Date}
                                style={inputStyle}
                                className="form-control"
                                max={getCurrentDateTime()} // Set the max attribute to the current date
                                onChange={(e) => {
                                  setFormInput({
                                    ...formInput,
                                    Date: e.target.value,
                                  });
                                  localStorage.setItem(
                                    "multipleReportDate",
                                    e.target.value
                                  );
                                }}
                              />
                            </div>
                            <div className="col-md-3">
                              <label htmlFor="ShiftId">Shift</label>
                              <select
                                className="form-select"
                                style={inputStyle2}
                                name="shiftName"
                                id="shiftName"
                                onChange={(e) => {
                                  setFormInput({
                                    ...formInput,
                                    shiftId: e.target.value,
                                  });
                                  localStorage.setItem(
                                    "MultipleReportShift",
                                    e.target.value
                                  );
                                }}
                                value={formInput.shiftId}
                              >
                                {shiftType.filter(shift => shift.isActive).map((shift, index) => {
                                  return <option key={index} value={shift.shiftId}>{shift.shiftName}</option>
                                })}
                              </select>
                            </div>
                            <div className="col-md-3 ">
                              <button
                                type="submit"
                                className={`btn mt-4 mr-2 ${isProd ? "search-ghmc" : "search-swm"
                                  }`}
                              >
                                Search
                              </button>
                              <button
                                type="submit"
                                className={`btn mt-4  ${isProd ? "search-ghmc" : "search-swm"
                                  }`}
                                onClick={() => {
                                  localStorage.removeItem("multipleReportDate");
                                  localStorage.removeItem(
                                    "MultipleReportShift"
                                  );
                                  setFormInput({
                                    Date: getCurrentDateTime(),
                                    shiftId: 1,
                                  });
                                }}
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div className="col-md-2">
                        <div className="text-end">
                          <button
                            className="btn btn-excel ms-auto mt-4"
                            onClick={downloadZoneAsExcel}
                          >
                            <i className="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                            Excel
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="card mt-3">
                      <div className="">
                        <div className="top-header">
                          <span> Zone Wise GVPs Multiple Clearance Report as on 
                            {formInput.Date?formattedDate(formInput.Date):getCurrentISTDate()} -{getShiftName(formInput.shiftId)} - (at {getCurrentDateTime1()})
                            </span>
                        </div>
                        {/* <CustomDataTable
                                                        columns={zoneColumns}
                                                        data={getZoneReport}
                                                        isLoading={isLoading}
                                                    /> */}
                        <CustomDataTable
                          data={GVPMultipleClearnceZoneDataWithTotal}
                          columns={zoneColumns}
                          link={true}
                          date={formInput.Date}
                        // editData={handleEditRoute}
                        // editRouteData={editRouteData}
                        // viewData={(id) => handleViewRoute(id)}
                        />
                      </div>
                    </div>
                  </TabPanel>
                  {/* Map View Tab */}
                  <TabPanel>
                    {isOptionsLoading && <Loader />}

                    <div className="row mt-3 align-content-center">
                      <div className="col-md-10">
                        <form
                          onSubmit={handleSubmit(searchCircleReport)}
                          onKeyDown={(e) => {
                            handleKeyDown(e, handleSubmit);
                          }}
                        >
                          <div className="row" style={{ textAlign: "justify" }}>
                            <div className="col-md-3 ">
                              <label htmlFor="Date">Date:</label>
                              <input
                                type="date"
                                name="date"
                                value={formInput1.Date}
                                style={inputStyle}
                                className="form-control"
                                max={getCurrentDateTime()} // Set the max attribute to the current date
                                onChange={(e) => {
                                  setFormInput1({
                                    ...formInput1,
                                    Date: e.target.value,
                                  });
                                  localStorage.setItem(
                                    "MultipleCircleDate",
                                    e.target.value
                                  );
                                }}
                              />
                            </div>
                            <div className="col-md-3 ">
                              <label htmlFor="ShiftId">Shift</label>
                              <select
                                className="form-select"
                                style={inputStyle2}
                                name="shiftId"
                                id="shiftName"
                                onChange={(e) => {
                                  setFormInput1({
                                    ...formInput1,
                                    shiftId: e.target.value,
                                  });
                                  localStorage.setItem(
                                    "multipleCircleShift",
                                    e.target.value
                                  );
                                }}
                                value={formInput1.shiftId}
                              >
                                {shiftType.filter(shift => shift.isActive).map((shift, index) => {
                                  return <option key={index} value={shift.shiftId}>{shift.shiftName}</option>
                                })}
                              </select>
                            </div>
                            <div className="col-md-3 ">
                              <button
                                type="submit"
                                className={`btn mt-4 mr-2 ${isProd ? "search-ghmc" : "search-swm"
                                  }`}
                              >
                                Search
                              </button>
                              <button
                                type="submit"
                                className={`btn mt-4  ${isProd ? "search-ghmc" : "search-swm"
                                  }`}
                                onClick={() => {
                                  localStorage.removeItem(
                                    "multipleCircleShift"
                                  );
                                  localStorage.removeItem("MultipleCircleDate");
                                  setFormInput1({
                                    Date: getCurrentDateTime(),
                                    shiftId: 1,
                                  });
                                }}
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-excel ms-auto mt-4"
                          onClick={downloadCircleAsExcel}
                        >
                          <i className="fa-solid fa-file-excel me-1 icon-container"></i>{" "}
                          Excel
                        </button>
                      </div>
                    </div>
                    <div className="card mt-3">
                      <div className="">
                        <div className="top-header">
                          <span>
                            {" "}
                            Circle Wise GVPs Multiple Clearance Report {formattedDate(formInput1.Date)} & {getShiftName(formInput1.shiftId)}
                          </span>
                        </div>
                        {/* <CustomDataTable
                                                        columns={zoneColumns}
                                                        data={getCircleReport}
                                                        isLoading={isLoading}
                                                    /> */}
                        <CustomDataTable
                          data={GVPMultipleClearnceDataWithTotal}
                          columns={circleColumns}
                          filterFunction={(data) =>
                            data.filter(
                              (item) => item.status === 1 || item.status === 0
                            )
                          }
                        // editData={handleEditRoute}
                        // editRouteData={editRouteData}
                        // viewData={(id) => handleViewRoute(id)}
                        />
                      </div>
                    </div>
                  </TabPanel>
                </Tabs>
                {/* TABLE */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GVPMultipleClearence;

const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  // const hour = String(now.getHours()).padStart(2, "0");
  // const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const inputStyle = {
  border: "1px solid #E2E2E2",
  padding: "15px",
  borderRadius: "0px",
};

const inputStyle2 = {
  border: "1px solid #E2E2E2",
  // padding: "15px",
  borderRadius: "0px",
};
